// extracted by mini-css-extract-plugin
module.exports = {"content":"ContentEventWrapper__content___1Is72","tpb":"ContentEventWrapper__tpb___1w2b7"};